export default "__VITE_PUBLIC_ASSET__c0022d36__"